//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Horizontal",
  data() {
    return {
      slide: 1,
      sets:5,
      window:4
    };
  },
  props: {
    genresTvShow: Array
  },
  methods: {
    details(id) {
      this.$store.dispatch('getTvShowDetails',id)
      this.$router.push({ name: "singleTvshows", params: { id: id } });
    },
    getSetOfShows(index){
      return this.genresTvShow ? this.genresTvShow.slice((index-1)*this.window,index*this.window): []
    }
  }
};
